
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import PageBase from "../../../../engines/modules/uiModule/PageBase";
import { OilFieldBuyPrams } from "../../../../engines/modules/uiModule/UIPrams";
import { PLATFORM_CODE } from "../../../../engines/services/ossService";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { getOilfieldConfig, getOilfieldConfigH5, oilfieldInfoType } from "./config/oilfieldConfig";

const { ccclass, property } = cc._decorator;

@ccclass
export default class oilfieldBuyPage extends PageBase {
    @property({ type: cc.Sprite, displayName: "油坑图片" })
    img_oilfield: cc.Sprite = null;
    @property({ type: cc.Label, displayName: "油坑名称" })
    lab_name: cc.Label = null;
    @property({ type: cc.Label, displayName: "油坑价格" })
    lab_price: cc.Label = null;
    @property({ type: cc.Label, displayName: "油坑内容" })
    lab_tips: cc.Label = null;

    @property({ type: cc.Node, displayName: "开采视频" })
    node_video: cc.Node = null;
    infoData: oilfieldInfoType = null

    callBack: () => void = null;
    async OnPageOpen(prams?: OilFieldBuyPrams) {
        if (prams) {
            let OilFieldConifg = getOilfieldConfig;
            if (O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5) {
                OilFieldConifg = getOilfieldConfigH5;
            }
            this.infoData = OilFieldConifg[prams.id];
            this.lab_name.string = this.infoData.name;
            this.lab_price.string = `售价：${data_control.getNumberFormat(this.infoData.buyPrice)}`;
            this.lab_tips.string = this.infoData.tips;
            this.node_video.active =false// oilfieldDataHelp.getData().mineTimes > 0;
            this.callBack = prams.callBack;
            
          if(this.infoData.spriteName&&this.infoData.spriteName!="")  utilsView.loadItemImg('res/'+this.infoData.spriteName, this.img_oilfield, null, BUNDLE_SMALL_NAME.oilfield);
        }
        super.OnPageOpen(prams)
    }
    clickTime: number = null;
    onClickMine() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        if (this.clickTime != null && new Date().getTime() - this.clickTime < 3000) return;
        this.clickTime = new Date().getTime()

        let func = () => {
            this.ClosePage();
            this.callBack && this.callBack();
        }
        if (this.node_video.active) {
            cc.game.pause();
            utilsModel.loadAndShowVideoAdTrans(async () => {
                cc.game.resume();
                func();
            }, () => {
                cc.game.resume();
            }, null, '蚂蚱贷款')
        } else func();
    }
}